export {default} from './LightBox'
export type {LightBoxProps} from './types'
